const rawApiBaseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api';

const normalizeApiBaseUrl = (url) => {
  const trimmed = url.replace(/\/+$/, '');
  return trimmed.endsWith('/api') ? trimmed : `${trimmed}/api`;
};

export const API_BASE_URL = normalizeApiBaseUrl(rawApiBaseUrl);

const localApiFallbacks = ['http://localhost:3000/api', 'http://localhost:3002/api'];

export const API_BASE_URL_CANDIDATES = import.meta.env.DEV
  ? Array.from(new Set([API_BASE_URL, ...localApiFallbacks.map(normalizeApiBaseUrl)]))
  : [API_BASE_URL];
